import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";

/**
 * MK1 (GO Frank 3 november 2026): deze Mac en de lokale modellen, in Instellingen > Model.
 *
 * Toont de chip en het geheugen, per lokaal model of het past (besluit Frank: hooguit 60 procent van het geheugen),
 * en het lokale advies (qwen3.8:27b zolang W2 open is). **ALLEEN LEZEN**: geen knop die downloadt of wisselt; dat
 * blijft een eigen GO (W2). Een wachter eist dat hier geen schrijfweg bij komt.
 */

/** De tekst bij "past", met onbekend als eigen uitkomst: er wordt niets beweerd wat niet gemeten is. PUUR. */
export function pastTekst(past) {
  if (past === true) return "past";
  if (past === false) return "past niet";
  return "onbekend";
}

/** De grootte als tekst, of leeg als Ollama hem niet meldt. PUUR. */
export function grootteTekst(gb) {
  return typeof gb === "number" ? `${String(gb).replace(".", ",")} GB` : "";
}

export default function MachineAdvies() {
  const { t } = useTaal();
  const [catalogus, setCatalogus] = useState(null);

  useEffect(() => {
    axios.get(`${API}/ollama/catalogus`).then(({ data }) => setCatalogus(data)).catch(() => setCatalogus(null));
  }, []);

  if (!catalogus) return null;
  const { machine = {}, lokaal = [], advies = null, past_deel: deel } = catalogus;
  const procent = Math.round((deel || 0) * 100);
  return (
    <section className="space-y-2 text-sm" data-testid="machine-advies">
      <p className="font-medium" data-testid="machine-regel">
        {t("Deze Mac: {chip}, {gb} GB", { chip: machine.chip || t("onbekend"), gb: machine.geheugen_gb || "?" })}
      </p>
      <p className="text-xs text-muted-foreground">
        {t("Een model past als het hooguit {procent} procent van het geheugen gebruikt; de rest is voor de context en de app.",
          { procent })}
      </p>
      {lokaal.length > 0 && (
        <ul className="space-y-1" data-testid="machine-modellen">
          {lokaal.map((m) => (
            <li key={m.naam} className="flex flex-wrap gap-x-2" data-testid="machine-model">
              <span className="font-mono">{m.naam}</span>
              {m.grootte_gb != null && <span className="text-muted-foreground">{grootteTekst(m.grootte_gb)}</span>}
              <span data-testid={`past-${m.naam}`}>{t(pastTekst(m.past))}</span>
            </li>
          ))}
        </ul>
      )}
      {advies && (
        <p data-testid="machine-advies-regel">
          {t("Advies voor deze Mac: {model}", { model: advies.model })}
          {advies.grootte_gb != null && ` (${grootteTekst(advies.grootte_gb)})`}
          {", "}{t(pastTekst(advies.past))}
          {!advies.geinstalleerd && <>{", "}{t("niet geinstalleerd")}</>}
          {advies.bron && <span className="text-muted-foreground">{"; "}{t(advies.bron)}</span>}
        </p>
      )}
      {catalogus.error && <p className="text-xs text-muted-foreground">{t("Ollama gaf geen lijst; de machine en het advies blijven zichtbaar.")}</p>}
    </section>
  );
}
